//判断手机号是否正确
function testPhone(phone) {
  let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
  return phoneReg.test(phone);
}

function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}
function sumOfAmount(arr) {
  // console.log(arr);
  let s = 0;
  for (let i = arr.length - 1; i >= 0; i--) {
    s += Number(arr[i].amount) * Number(arr[i].count);
  }
  return s;
}

function fakeByStar60(str) {
  if (!str) return ""
  var length = str.length
  var str1 = ""
  var str2 = ""
  const reg = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
  const isEmail = reg.test(str)
  if (isEmail) {
    str1 = str.split("@")[0];
    str2 = str.split("@")[1];
    length = str1.length
  }
  let starLength = Math.floor(length * 60 / 100);
  let frontLength = Math.ceil(length * 25 / 100);
  let backLength = length - starLength - frontLength;
  var star = "";
  for (let i = 0; i < starLength; i++) {
    star += "*";
  }
  if (isEmail) {
    str = str1.substr(0, frontLength) + star + str1.substr(length - backLength) + "@" + str2
  } else {
    str = str.substr(0, frontLength) + star + str.substr(length - backLength);
  }
  return str
}

function fakeMobile(str, frontLen, endLen) {
  var len = str.length - frontLen - endLen;
  var star = "";
  for (var i = 0; i < len; i++) {
    star += "*";
  }
  return str.substr(0, frontLen) + star + str.substr(str.length - endLen);
}
function sumOfCount(arr) {
  let s = 0;
  for (let i = arr.length - 1; i >= 0; i--) {
    s += Number(arr[i].count);
  }
  return s;
}
function getUrlValue(kValue) {
  var url = window.location.href; //当前页面的地址
  var reg = /([^?&=]+)=([^?&=]+)/g,
    obj = {},
    str = url;
  url.replace(reg, function () {
    obj[arguments[1]] = arguments[2];
  });
  for (var keyName in obj) {
    if (keyName == kValue) {
      return obj[keyName];
      // break;
    }
  }
}

function isNumberBy100(ssn) {
  if (ssn) {
    var re = /^[0-9]*[0-9]$/i; //校验是否为数字
    return re.test(ssn) && ssn % 100 === 0
  } else {
    return true
  }
}
function isNumberBy10(ssn) {
  if (ssn) {
    var re = /^[0-9]*[0-9]$/i; //校验是否为数字
    return re.test(ssn) && ssn % 10 === 0
  } else {
    return true
  }
}

module.exports = {
  testPhone,
  isMobile,
  sumOfAmount,
  sumOfCount,
  getUrlValue,
  fakeMobile,
  isNumberBy100,
  isNumberBy10,
  fakeByStar60
};
